import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from '../../../../../services/user';
import { ItemsService } from '../../../../../services/items.service';
import { SuppliesService } from '../../../../../services/supplies';
import { SuppliesRequests } from '../../../../../interfaces/SuppliesRequests';
import { FinancialManagerService } from '../../../../../services/financial-manager';

@Component({
  selector: 'app-suppliespagemobile',
  templateUrl: './suppliespagemobile.component.html',
  styleUrl: './suppliespagemobile.component.scss'
})
export class SuppliespagemobileComponent {

  allData: any[] = [];
  allWareHouses: any[] = [];

  contentReady = true;
  isLoadingMore = false;
  noData = false;
  searched = false;

  accountType!: string;
  isAdmin = false;
  isSubAdmin = false;
  isWarehouse = false;
  isAr: boolean = localStorage.getItem('language') == 'ar';

  userId!: any;
  warehouseid!: any;

  page = 1;
  totalPages = 1;
  totalItems = 0;
  stockTotal = 0;

  payedId!: any;
  showRejectPopUp = false;
  showinstalimentPopUp = false;

  not_payed = '';
  payed = '';
  instaliment_price = '';
  instaliment_period = '';

  constructor(
    private router: Router,
    private _userService: UserService,
    private _itemsService: ItemsService,
    private _financialManager: FinancialManagerService,
    private _suppliesService: SuppliesService,
  ) { }

  get canShowStockTransfer(): boolean {
    return this.isAdmin && this.allWareHouses.length > 1;
  }

  ngOnInit(): void {
    this.warehouseid = localStorage.getItem('posId');
    this.getWarehouses();
    this.getUserId();
    this.getAccountTypeAndLoadData();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached && !this.contentReady && !this.isLoadingMore && this.page < this.totalPages) {
      this.loadMore();
    }
  }

  private getWarehouses(): void {
    this._itemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res?.warehouse || [];
      },
      error: (err) => console.error(err),
    });
  }

  private getUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];
      },
      error: (error) => console.error(error),
    });
  }

  private getAccountTypeAndLoadData(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == '1' || this.accountType == '10';
        this.isSubAdmin = this.accountType == '6';
        this.checkWarehouseType(this.warehouseid);
        this.getAllSuppliesData(1, this.warehouseid);
      },
      error: (error) => console.error(error),
    });
  }

  private checkWarehouseType(warehouseId: any): void {
    if (!warehouseId) return;

    this._userService.getWarehouseType(Number(warehouseId)).subscribe({
      next: (data) => {
        this.isWarehouse = data['warehouses_type'] != '1';
      },
      error: (error) => console.error(error),
    });
  }

  applyWareHouse(warehouseId: any): void {
    this.warehouseid = warehouseId;
    this.page = 1;
    this.totalPages = 1;
    this.checkWarehouseType(warehouseId);
    this.getAllSuppliesData(1, warehouseId);
  }

  getAllSuppliesData(page: number, warehouseId: any, append = false): void {
    if (append) {
      this.isLoadingMore = true;
    } else {
      this.contentReady = true;
    }

    this.searched = false;

    this._suppliesService.getSuppliesRequests(page, warehouseId).subscribe({
      next: (data) => {
        const pageData = data['data'] || [];

        this.allData = append ? [...this.allData, ...pageData] : pageData;
        this.page = page;
        this.stockTotal = data['total'] || 0;
        this.totalItems = data['total'] || 0;
        this.totalPages = data['last_page'] || 1;

        this.contentReady = false;
        this.isLoadingMore = false;
        this.noData = this.allData.length === 0;
      },
      error: (error) => {
        this.contentReady = false;
        this.isLoadingMore = false;
        console.error(error);
      },
    });
  }

  loadMore(): void {
    if (this.isLoadingMore || this.page >= this.totalPages) return;
    this.getAllSuppliesData(this.page + 1, this.warehouseid, true);
  }

  toggleProducts(element: any): void {
    element.showAllProducts = !element.showAllProducts;
  }

  canTakeAction(element: any): boolean {
    return element?.status != 'rejected' && element?.status != 'accepted';
  }

  hasCreditAction(element: any): boolean {
    return element?.not_payed != null && element?.not_payed != 'null' && String(element?.type) == '1';
  }

  hasInstallmentAction(element: any): boolean {
    return element?.installment_price != null && element?.installment_price != 'null' && String(element?.type) == '2';
  }

  accStatement(phone: any): void {
    if (!phone) return;
    this.getStatementByPhone(phone);
  }

  getStatementByPhone(phone: string): void {
    this.router.navigate(['/accountstatement'], { queryParams: { phone } });
  }

  details(element: any): void {
    this.router.navigate(['/supplieinvoice'], { queryParams: { id: element.id } });
  }

  tolist(list: any): any[] {
    if (list === null || list === undefined || list === 'undefined') return [];

    if (Array.isArray(list)) {
      if (list.length === 1 && typeof list[0] === 'string') {
        return list[0].split(',').map((item: string) => item.trim());
      }
      return list;
    }

    return String(list).split(',').map((item: string) => item.trim());
  }

  drawProducts(element: any, price: any, qty: any, newPrice: any, newqty: any): string {
    const oldPrice = Number(price) || 0;
    const oldQty = Number(qty) || 0;
    const incomingPrice = Number(newPrice) || 0;
    const incomingQty = Number(newqty) || 0;

    const oldTotal = oldPrice * oldQty;
    const incomingTotal = incomingQty * incomingPrice;
    const totalQty = oldQty + incomingQty;
    const averagePrice = totalQty > 0 ? Math.ceil((oldTotal + incomingTotal) / totalQty) : oldPrice;
    const totalNewQty = oldQty + incomingQty;
    const difference = averagePrice - oldPrice;

    if (!this.isAr) {
      return `${element} : price ${oldPrice} - quantity ${oldQty} | new price ${averagePrice} - new quantity ${totalNewQty} difference is ${difference}`;
    }

    return `${element} : السعر ${oldPrice} - الكمية ${oldQty} | السعر هيبقي ${averagePrice} - الكمية هتبقي ${totalNewQty} فرق بين السعرين هو ${difference}`;
  }

  getNewPrice(price: any, qty: any, newPrice: any, newqty: any): number[] {
    const oldPrices = this.tolist(price);
    const oldQtys = this.tolist(qty);
    const incomingPrices = this.tolist(newPrice);
    const incomingQtys = this.tolist(newqty);

    return oldPrices.map((oldPriceValue: any, index: number) => {
      const oldPrice = Number(oldPriceValue) || 0;
      const oldQty = Number(oldQtys[index]) || 0;
      const incomingPrice = Number(incomingPrices[index]) || 0;
      const incomingQty = Number(incomingQtys[index]) || 0;

      const totalQty = oldQty + incomingQty;
      if (totalQty <= 0) return 0;

      const averagePrice = Math.ceil(((oldPrice * oldQty) + (incomingPrice * incomingQty)) / totalQty);
      return averagePrice - oldPrice;
    });
  }

  sumArray(array: any[], qty: any[]): number {
    const fixedArray = array.map((value: any, index: number) => (Number(value) || 0) * (Number(qty[index]) || 0));
    return fixedArray.reduce((sum: number, value: number) => sum + value, 0);
  }

  addEx(orderid: any, total: any): void {
    const bonusPayload = {
      warehouse_id: localStorage.getItem('posId'),
      employee_id: this.userId,
      username: localStorage.getItem('username'),
      amount: total,
      note: String(orderid),
      type: '4'
    };

    this._financialManager.addexpenses(bonusPayload).subscribe({
      next: () => { },
      error: (error) => console.error(error),
    });
  }

  acceptRequest(id: string, productsIds: any, qtys: any, prices: any, cost: any, costqty: any, type: any, payed: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then((confirmResult) => {
      if (!confirmResult.isConfirmed) return;

      Swal.fire({
        title: this.isAr ? 'عايز السعر يسمع' : 'update prices?',
        showCancelButton: true,
        confirmButtonText: this.isAr ? 'اه' : 'YES',
        cancelButtonText: this.isAr ? 'لا' : 'no'
      }).then((priceResult) => {
        const finalPrices = priceResult.isConfirmed ? prices : this.tolist(prices).map(() => 0);
        this.runAcceptRequest(id, productsIds, qtys, finalPrices, cost, costqty, type, payed);
      });
    });
  }

  private runAcceptRequest(id: string, productsIds: any, qtys: any, prices: any, cost: any, costqty: any, type: any, payed: any): void {
    this.contentReady = true;

    this._suppliesService.updateStockAfterAccept(id, productsIds, qtys, prices).subscribe({
      next: () => {
        this._suppliesService.acceptSupplyRequest(id, true, this.userId).subscribe({
          next: () => {
            if (this.isWarehouse) {
              if (String(type) == '1') {
                this.addEx(id, payed);
              } else {
                this.addEx(id, this.sumArray(this.tolist(cost), this.tolist(costqty)));
              }
            }

            this.contentReady = false;
            Swal.fire({
              icon: 'success',
              title: this.isAr ? 'تم تحديث المخزون بنجاح' : 'Stock Updated Successfully',
              confirmButtonText: this.isAr ? 'تمام' : 'ok',
            });
            this.getAllSuppliesData(1, this.warehouseid);
          },
          error: (err) => {
            this.contentReady = false;
            console.error(err);
          }
        });
      },
      error: (err) => {
        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل في تحديث المخزون' : 'Failed to Update Stock',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        console.error('Stock update error:', err);
      }
    });
  }

  rejectRequest(id: string): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.contentReady = true;
      this._suppliesService.acceptSupplyRequest(id, false, this.userId).subscribe({
        next: () => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? 'تم رفض الطلب بنجاح' : 'Request Rejected Successfully',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          this.getAllSuppliesData(1, this.warehouseid);
        },
        error: (err) => {
          this.contentReady = false;
          Swal.fire({
            icon: 'error',
            title: this.isAr ? 'فشل رفض الطلب' : 'Failed to Reject Request',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
          console.error(err);
        }
      });
    });
  }

  changeCredit(id: any, not_payed: any, payed: any): void {
    this.not_payed = not_payed;
    this.payed = payed;
    this.payedId = id;
    this.showRejectPopUp = true;
  }

  changeInstalimentValues(id: any, instaliment_price: any, instaliment_period: any): void {
    this.instaliment_period = instaliment_period;
    this.instaliment_price = instaliment_price;
    this.payedId = id;
    this.showinstalimentPopUp = true;
  }

  close(): void {
    this.showRejectPopUp = false;
    this.showinstalimentPopUp = false;
  }

  onSubmit(): void {
    this.close();

    if (this.not_payed == null || this.payed == null || this.payedId == null) return;

    this.contentReady = true;
    this._suppliesService.changeCreditValues(this.payedId, this.payed, this.not_payed).subscribe({
      next: () => {
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم تحديث القيم بنجاح' : 'Values Updated Successfully',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        this.getAllSuppliesData(1, this.warehouseid);
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل في تحديث القيم' : 'Failed to Update Values',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      },
    });
  }

  onSubmitInstaliment(): void {
    this.close();

    if (this.instaliment_period == null || this.instaliment_price == null || this.payedId == null) return;

    this.contentReady = true;
    this._suppliesService.changeInstalimentValues(this.payedId, this.instaliment_price, this.instaliment_period).subscribe({
      next: () => {
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم تحديث القيم بنجاح' : 'Values Updated Successfully',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        this.getAllSuppliesData(1, this.warehouseid);
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل في تحديث القيم' : 'Failed to Update Values',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      },
    });
  }

  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }

  convertDate(dateString: any): string {
    return this.formatDate(dateString);
  }
}
